<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>

<div class="form-container" *ngIf="isSuperAdmin">
	<div class="mt-controls">
		<dx-date-box [(value)]="date" type="date" displayFormat="dd/MM/yyyy" [max]="today" (onValueChanged)="changeDate($event)" [width]="150"></dx-date-box>
		<dx-button stylingMode="outlined" type="default" text="Today" (onClick)="viewToday()"></dx-button>
		<dx-tag-box [items]="employees" [(value)]="selectedUserProfileIds" displayExpr="name" valueExpr="id" placeholder="Nobody selected"
			[searchEnabled]="true" [showSelectionControls]="true" [maxDisplayedTags]="3" [showMultiTagOnly]="false" [width]="340"
			(onValueChanged)="applyFilter()"></dx-tag-box>
		<dx-button stylingMode="text" type="default" text="All" (onClick)="selectAll()"></dx-button>
		<dx-button stylingMode="text" type="default" text="None" (onClick)="selectNone()"></dx-button>
		<span class="mt-count">{{ visibleRows.length }} of {{ rows.length }}</span>
	</div>

	<dx-tabs *ngIf="tabs.length > 1" [dataSource]="tabs" [selectedIndex]="selectedTabIndex" (onItemClick)="selectTab($event)"></dx-tabs>

	<div class="mt-legend">
		<div *ngFor="let key of legend"><span class="mt-key" [style.background]="key.colour"></span>{{ key.label }}</div>
	</div>

	<div class="mt-ruler">
		<span *ngFor="let tick of ticks" [style.left.%]="tick.percent">{{ tick.label }}</span>
	</div>

	<!-- One band per employee, the same band the machine time tab on a profile draws for one person's days. -->
	<div class="mt-day" *ngFor="let row of visibleRows">
		<div class="mt-day-label">
			<b>{{ row.name }}</b>
			<span>{{ row.siteName || 'No site' }}</span>
		</div>
		<div class="mt-band">
			<!-- Clocking in and out as lines across the chart, wherever they fall. -->
			<div class="mt-mark" *ngIf="row.clock.show" [style.left.%]="row.clock.left" [title]="'Clocked in ' + row.clock.inLabel">
				<span>{{ row.clock.inLabel }}</span>
			</div>
			<div class="mt-mark mt-mark-out" *ngIf="row.clock.show && row.clock.outLabel !== 'unknown'"
				[style.left.%]="row.clock.left + row.clock.width" [title]="'Clocked out ' + row.clock.outLabel">
				<span>{{ row.clock.outLabel }}</span>
			</div>
			<div class="mt-seg" *ngFor="let seg of row.bars" [style.left.%]="seg.left" [style.width.%]="seg.width"
				[style.background]="seg.colour" (mouseenter)="showTip(seg, $event)" (mouseleave)="hideTip()"></div>
			<span class="mt-empty" *ngIf="row.bars.length === 0">{{ row.clockIn ? 'Clocked in, no machine status set' : 'No activity' }}</span>
		</div>
		<div class="mt-day-stat">
			<div class="mt-clock-pair">
				<span><em>In</em><b>{{ row.clock.inLabel }}</b></span>
				<span><em>Out</em><b [class.unknown]="row.clock.outLabel === 'unknown'">{{ row.clock.outLabel }}</b></span>
			</div>
			<span class="mt-clock-source" *ngIf="row.clock.source">{{ row.clock.source }}</span>
			<span>{{ row.summary }}</span>
		</div>
		<button class="mt-drop" type="button" title="Take this employee off the view" (click)="removeEmployee(row.userProfileId)"><i class="fal fa-times"></i></button>
	</div>

	<toolroom-loader *ngIf="isLoading" text="Loading machine time" variant="draw"></toolroom-loader>
	<div class="mt-empty-week" *ngIf="isLoading === false && rows.length === 0">Nothing recorded for this day.</div>
	<div class="mt-empty-week" *ngIf="isLoading === false && rows.length > 0 && visibleRows.length === 0">Nobody selected on this tab.</div>
</div>

<div class="mt-empty-week" *ngIf="isSuperAdmin === false">This page is for Super Admins only.</div>

<div class="mt-tip" *ngIf="tip" [style.left.px]="tip.x" [style.top.px]="tip.y">
	<b><span class="mt-tip-key" [style.background]="tip.colour"></span>{{ tip.status }}</b>
	<div class="mt-tip-time">{{ tip.times }}</div>
	<div class="mt-tip-meta">{{ tip.duration }}<span *ngIf="tip.machineName"> &middot; {{ tip.machineName }}</span></div>
	<div class="mt-tip-meta" *ngIf="tip.operation">{{ tip.operation }}</div>
</div>
